module.exports = __webpack_public_path__ + "img/ico_menual06_on.2cd2d176.svg";